module.exports = __webpack_public_path__ + "1d87d60dd118ad993482ecc1b027ec79.png";